// extracted by mini-css-extract-plugin
export default {"button":"wn7uuTyn9K0U_AkxdX2V","icon":"RSk698m9BNeNQRZW7cov","placeHolderShimmer":"hV7SifupkEuTT7JI8zvT"};